import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/core/http/api.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ProviderService {

    constructor(private apiService: ApiService) {}


    public getProviders(startIndex = 0, pageSize = 40, sorting = '', search = '', providerTypeEnum = null, status = 'active', searchOnNamesYN = false): Observable<any> {
      const searchParams = new HttpParams()
      .set('startIndex', startIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sorting', sorting)
      .set('search', search)
      .set('providerTypeEnum', providerTypeEnum)
      .set('status', status)
      .set('searchOnNamesYN', searchOnNamesYN.toString());

      // console.log('getDoctors', search);
      // return this.apiService.Get('users', searchParams);
      return this.apiService.Get('providers', searchParams);
      // return of({Data: {TotalItems: 64, Items: [{Id: 1, AuthUserInitial: 'a'}, {Id: 2, AuthUserInitial: 'b'}, {Id: 3, AuthUserInitial: 'c'}, {Id: 4, AuthUserInitial: 'd'}, {Id: 5, AuthUserInitial: 'e'}, {Id: 6, AuthUserInitial: 'f'}, {Id: 7, AuthUserInitial: 'i'}, {Id: 8, AuthUserInitial: 'j'}, {Id: 9, AuthUserInitial: 'k'}, {Id: 10, AuthUserInitial: 'l'}, {Id: 11, AuthUserInitial: 'm'}, {Id: 12, AuthUserInitial: 'n'}, {Id: 13, AuthUserInitial: 'o'}, {Id: 14, AuthUserInitial: 'p'}, {Id: 15, AuthUserInitial: 'q'},  ]}});
    }

}
